let availableCarousels = document.querySelectorAll('.splide');

if (availableCarousels.length) {
    for ( let carousel of availableCarousels ) {
        let parentPanel = carousel.closest('.gallery-panel');
        let galleryThumbnails = parentPanel.querySelectorAll('.gallery-panel-image');
        let lightbox = parentPanel.querySelector('.gallery-panel-lightbox');
        let lightboxBackdrop = lightbox.querySelector('.lightbox-backdrop');
        let lightboxClose = lightbox.querySelector('.lightbox-close');
        let progressBar = lightbox.querySelector('.carousel-progress-bar');

        carousel = new Splide('.splide', {
            type: 'fade',
            classes: {
                arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                arrow : 'splide__arrow relative z-5 rounded-l-lg w-14 h-16 p-2 bg-hgwa-black-1 bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-hgwa-grey-6 disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                prev  : 'splide__arrow--prev left-0 md:left-[calc(-1.25rem_-_2.5vw)] 2xl:-left-16 rotate-180',
                next  : 'splide__arrow--next right-0 md:right-[calc(-1.25rem_-_2.5vw)] 2xl:-right-16',
            },
        });

        function closeLightBox() {
            lightbox.classList.add('opacity-0');
            lightbox.classList.add('pointer-events-none');
            document.documentElement.classList.toggle('body-lock-scroll-modal');
            const lightboxHide = setTimeout(() => {
                lightbox.classList.add('hidden');
                clearTimeout(lightboxHide);
            }, 300);
        }

        function openLightBox() {
            lightbox.classList.remove('hidden');
            document.documentElement.classList.toggle('body-lock-scroll-modal');
            const lightboxShow = setTimeout(() => {
                lightbox.classList.remove('opacity-0');
                lightbox.classList.remove('pointer-events-none');
                clearTimeout(lightboxShow);
            }, 50);
        }

        // Closes lightbox on backdrop/close button press

        lightboxBackdrop.addEventListener('click', () => {
            closeLightBox();
        });

        lightboxClose.addEventListener('click', () => {
            closeLightBox();
        });

        // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

        document.addEventListener("keydown", (e) => {
            if (!lightbox.classList.contains('hidden')) {
                if (e.key === "Escape") {
                    closeLightBox();
                }
                else if (e.key === "ArrowRight") {
                    carousel.go('+${i}');
                }
                else if (e.key === "ArrowLeft") {
                    carousel.go('-${i}');
                }
            }
        });

        // Opens lightbox and navigates carousel to the thumbnail that was pressed

        for ( let thumbnail of galleryThumbnails ) {
            thumbnail.addEventListener('click', () => {
                if (thumbnail.dataset.slide.length) {
                    carousel.go( parseInt(thumbnail.dataset.slide) );
                }
                openLightBox();
            });
        }

        // Updates carousel progress bar width

        carousel.on('mounted move', function () {
            let end = carousel.Components.Controller.getEnd() + 1;
            progressBar.style.width = String(100 * (carousel.index + 1) / end) + '%';
        });

        carousel.mount();
    }
}

